export default {
    url: '/main_total',
    template: require('./view.html'),
    data: {
        title: 'Main total',
        role: 'tutorial',
        priority: 801,
    },
    reloadOnSearch: false,
};

